import React, { useEffect, useState } from "react";
import {
  formatDateAndTimeFromUTC,
  getCurrentTimeWithSeconds,
} from "../../../components/shared/utils";
import { Col, Row } from "react-bootstrap";
import InputWithLabel from "../../../components/shared/fields/InputWithLabel";
import SelectBox from "../../../components/shared/fields/SelectBox ";
import { useGetFruitsQuery } from "../../Receiving/unloading/unloadingApi";
import CommonModal from "../../../components/shared/modalLayout/CommonModal";
import Button from "../../../components/shared/buttons/button";
import InputWithIcon from "../../../components/shared/fields/InputWithIcon";
import { RefreshSvg } from "../../../svgFiles/RefreshSvg";
import {
  useCreateBrokeragePackingMaterialMutation,
  useGetBrokerageSummaryQuery,
  useUpdateBrokeragePackingMutation,
} from "../materialEntered/materialApi";
import toast from "react-hot-toast";
import useTranslator from "../../../hooks/useTranslator";
import { getCurrentDate } from "../../../helpers/Utils";

const CheeksStripsModal = ({ show, setShow, record, mode, acttiveTab }) => {
  const { _t } = useTranslator();
  const currentDate = getCurrentDate("YYYY-MM-DD");
  const [date, setDate] = useState(currentDate);
  const { data: summaryData } = useGetBrokerageSummaryQuery({
    date,
    tab: "packaging",
  });
  const { data: matricsData } = useGetBrokerageSummaryQuery({
    date,
    tab: "metrics",
  });
  const cheeksTotalKg = Number(summaryData.total_cheeks_kg_entered);
  const usedKgCheeks = matricsData.total_cheeks_entered_kg;
  const leftKgCheeks = cheeksTotalKg - usedKgCheeks;
  const leftKgStrips =
    summaryData?.total_strips_kg_entered - matricsData?.total_stripe_entered_kg;
  const [createData] = useCreateBrokeragePackingMaterialMutation();
  const [updateData] = useUpdateBrokeragePackingMutation();
  const { data: fruitList } = useGetFruitsQuery();

  const initialFormData = {
    prime_kg: "0",
    fruit_type_id: "",
    time: getCurrentTimeWithSeconds(),
    prime_lite_kg: "0",
    trash_kg: "0",
    cheeks_entered: "0",
    cheeks_entered_kg: "0",
    stripes_entered_kg: "0",
    stripes_entered: "0",
    type: "",
  };

  const [formData, setFormData] = useState(initialFormData);
  useEffect(() => {
    if (mode === "edit" && record) {
      const updatedFormData = { ...initialFormData };

      for (const key in record) {
        if (key in initialFormData) {
          updatedFormData[key] = record[key];
        }
      }
      if (record.created_at) {
        const timeFromCreatedAt = formatDateAndTimeFromUTC(
          record.created_at
        ).time;
        updatedFormData.time = timeFromCreatedAt;
      }

      setFormData(updatedFormData);
    } else {
      setFormData(initialFormData);
    }
  }, [mode, record, show]);
  const handleClose = () => {
    setShow(false);
  };

  const handleSubmit = async (e) => {
    let payload = { ...formData };

    // Validate KG limits
    if (mode === "add") {
      if (
        formData.type === "cheek" &&
        Number(formData.cheeks_entered_kg) > leftKgCheeks
      ) {
        toast.error(
          `_t("max_add_limit", "You can add a maximum of") ${leftKgCheeks} kg`
        );
        return;
      }

      if (
        formData.type === "stripe" &&
        Number(formData.stripes_entered_kg) > leftKgStrips
      ) {
        toast.error(
          `${_t(
            "max_add_limit",
            "You can add a maximum of"
          )} ${leftKgStrips} kg`
        );
        return;
      }
    }

    // Adjust payload based on type
    if (formData.type === "cheek") {
      delete payload.stripes_entered;
      delete payload.stripes_entered_kg;
    } else if (formData.type === "stripe") {
      delete payload.cheeks_entered;
      delete payload.cheeks_entered_kg;
    }

    // Check sum only in edit mode
    // if (mode === "edit") {
    const sum =
      Number(formData.prime_kg) +
      Number(formData.prime_lite_kg) +
      Number(formData.trash_kg);

    const expectedTotal =
      formData.type === "cheek"
        ? Number(formData.cheeks_entered_kg)
        : Number(formData.stripes_entered_kg);

    if (sum !== expectedTotal) {
      toast.error(
        `Sum of Prime KG, Prime Lite KG, and Trash KG must equal ${
          formData.type === "cheek" ? "Cheeks" : "Strips"
        } KG (${expectedTotal})`
      );
      return;
    }
    // }

    const mutation = mode === "add" ? createData : updateData;

    try {
      const finalPayload =
        mode === "add"
          ? payload
          : {
              id: record?.id,
              requestBody: {
                prime_kg: formData.prime_kg,
                prime_lite_kg: formData.prime_lite_kg,
                trash_kg: formData.trash_kg,
              },
            };

      await mutation(finalPayload).unwrap();
      handleClose();
    } catch (error) {
      console.error("Error creating/updating manager:", error);
      toast.error(_t("something_went_wrong_while_saving", "Something went wrong while saving."));
    }
  };

  const handleChange = (e) => {
    const { name, value } = e.target;

    let updatedFormData = {
      ...formData,
      [name]: value,
    };

    setFormData(updatedFormData);
  };
  const renderFormFields = () => (
    <>
      <Col lg={6}>
        <SelectBox
          label={_t("fruit_type", "Fruit Type")}
          name="fruit_type_id"
          options={fruitList?.data.map((list) => ({
            value: list.id,
            label: list.name,
          }))}
          value={formData.fruit_type_id}
          required={false}
          onChange={handleChange}
          disabled={mode === "edit"}

          // disabled={mode === "view"}
        />
      </Col>
      <Col lg={6}>
        <InputWithLabel
          label={_t("time", "Time")}
          type={mode === "add" ? "time" : "text"}
          name="time"
          value={formData.time}
          onChange={handleChange}
          disabled={true}
          placeholder={_t("prime", "Prime")}
        />
      </Col>
      <Col lg={6}>
        <SelectBox
          label={_t("type", "Type")}
          type="text"
          name="type"
          value={formData.type}
          options={[
            { value: "cheek", label: _t("cheeks", "Cheeks") },
            { value: "stripe", label: _t("strips", "Strips") },
          ]}
          onChange={handleChange}
          disabled={mode === "edit"}
        />
      </Col>
      {formData.type === "cheek" && (
        <>
          <Col lg={6}>
            <InputWithIcon
              label={_t("cheeks_kg", "Cheeks KG")}
              type="number"
              name="cheeks_entered_kg"
              value={formData.cheeks_entered_kg}
              onChange={handleChange}
              icon={RefreshSvg}
              placeholder={"0"}
              disabled={mode === "edit"}
            />
          </Col>
        </>
      )}{" "}
      {formData.type === "stripe" && (
        <>
          <Col lg={6}>
            <InputWithIcon
              label={_t("strips_kg", "Strips KG")}
              type="number"
              name="stripes_entered_kg"
              value={formData.stripes_entered_kg}
              onChange={handleChange}
              placeholder={"0"}
              disabled={mode === "edit"}
              icon={RefreshSvg}
            />
          </Col>
        </>
      )}
      {(formData.type === "stripe" || formData.type === "cheek") && (
        <>
          <Col lg={6}>
            <InputWithIcon
              label={_t("prime_kg", "Prime KG")}
              type="number"
              name="prime_kg"
              icon={RefreshSvg}
              value={formData.prime_kg}
              onChange={handleChange}
              placeholder={"0"}
            />
          </Col>
          <Col lg={6}>
            <InputWithIcon
              label={_t("second_kg", "Second KG")}
              icon={RefreshSvg}
              type="number"
              name="prime_lite_kg"
              value={formData.prime_lite_kg}
              onChange={handleChange}
              placeholder={"0"}
            />
          </Col>
          <Col lg={6}>
            <InputWithIcon
              label={_t("trash_kg", "Trash KG")}
              type="number"
              icon={RefreshSvg}
              name="trash_kg"
              value={formData.trash_kg}
              onChange={handleChange}
              placeholder={"0"}
            />
          </Col>
        </>
      )}
    </>
  );

  return (
    <CommonModal
      show={show}
      handleClose={handleClose}
      setShow={setShow}
      title={
        mode === "add"
          ? _t("add_data", "Add Data")
          : _t("edit_data", "Edit Data")
      }
      children={formData}
    >
      <Row>{renderFormFields()}</Row>

      <Row>
        <Col className="text-end">
          <Button
            label={_t("save_changes", "Save Changes")}
            size="small"
            onClick={handleSubmit}
            //   isLoading={isCreating || "isUpdating"}
          />
        </Col>
      </Row>
    </CommonModal>
  );
};

export default CheeksStripsModal;
